import FieldsCreditBundle from "graphql/fields/FieldsCreditBundle";
import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
    created_at
    name
    status

    credit_bundle {
        ${FieldsCreditBundle}
    }
`;
